import { useEffect, useRef } from "react";

export const soundsBasePath = "/static/sounds";

export enum SoundCatalog {
	Connected = "connect-chime.mp3",
	Incoming = "incoming-chime.mp3",
	Chat = "chat_chime.mp3",
	EventDetected = "event-detected.mp3",
	CameraShutter = "event-detected.mp3"
}

export interface UseSound {
	sound: SoundCatalog;
}

export const useSound = (sound: SoundCatalog) => {
	const howl = useRef<Howl>();
	useEffect(() => {
		howl.current = new Howl({
			src: [`${soundsBasePath}/${sound}`],
			loop: false
		});
	}, [sound]);

	const play = () => {
		return howl.current?.play();
	};

	return {
		play
	};
};
